import axiosHttp from "services/axiosHttp";
import { MEAL_BASE_URL } from "configs/AppConfig";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchMealDeductionList = createAsyncThunk("fetchMealDeductionList", async ({ filters, type, page, limit }, { rejectWithValue }) => {
	const params = new URLSearchParams({
		keyword: filters?.keyword ?? "",
		startDate: filters?.startDate ?? "",
		endDate: filters?.endDate ?? "",
		page: page,
		limit: limit,
		location: filters?.location_id ?? "",
		// consolidated asks the API to collapse the range into one row per record
		groupBy: filters?.groupBy ?? "consolidated",
	});

	try {
		const response = await axiosHttp.get(`${MEAL_BASE_URL}deduction-reports/${type}?${params}`);
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || "Something went wrong");
	}
});

const MealDeductionListSlice = createSlice({
	name: "MealDeductionListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchMealDeductionList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchMealDeductionList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.currentPage;
			state.total = action.payload.total;
		});

		builder.addCase(fetchMealDeductionList.rejected, (state, action) => {
			state.isLoading = false;

			if (action.error.message) {
				state.error = action.error.message;
			} else {
				state.error = "Unknown error occurred";
			}
		});
	},
});

export default MealDeductionListSlice.reducer;
